import React from 'react';
import './pagefooter.css';
import { Helmet } from "react-helmet-async";

const Membership = () => (
  <>
  <Helmet>
    <title>
      Best Membership Plans | No. 1 Physiotherapy & S&C in Udupi | AIKYAM
    </title>
    <meta
      name="description"
      content="Join Udupi's best sports science and No. 1 physiotherapy center. Explore top-rated membership plans for elite strength & conditioning (S&C), injury rehab, and athlete training serving Udupi and Manipal."
    />
    <meta
      name="keywords"
      content="Best physiotherapy membership udupi, no 1 strength and conditioning packages manipal, top rated sports rehab udupi, best fitness membership mangalore, premium S&C plans"
    />
    <link rel="canonical" href="https://aikyamsports.com/membership" />

    {/* Open Graph */}
    <meta property="og:title" content="Best Membership Plans | No. 1 Physiotherapy & S&C in Udupi | AIKYAM" />
    <meta
      property="og:description"
      content="Join the No. 1 rated AIKYAM Sports Science for top-tier sports physiotherapy, athlete development, and premium strength & conditioning programs."
    />
    <meta property="og:url" content="https://aikyamsports.com/membership" />
    <meta property="og:type" content="website" />
    <meta property="og:image" content="https://aikyamsports.com/logo11.png" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Best Membership Plans | No. 1 Physiotherapy & S&C in Udupi" />
    <meta
      name="twitter:description"
      content="Udupi's top-rated membership plans for physiotherapy, elite rehabilitation, and strength & conditioning."
    />
    <meta name="twitter:image" content="https://aikyamsports.com/logo11.png" />
  </Helmet>

  <div className="policy-page">
    <h1> Best Membership & Training Plans</h1>
    <p>Join the <strong>No. 1 rated</strong> fitness and performance programs tailored to your needs. We offer premium, flexible membership plans designed to help you achieve elite health and performance results with the best coaches .</p>

    <h2>Our Top-Rated Packages</h2>
    <ul>
      <li><strong>Best-in-Class Consultation & Clinical Assessment:</strong> 3 sessions/week (12 sessions/month)</li>
      <li><strong>Physiotherapy Standard:</strong> 5 sessions/week (20 sessions/month), Data-Centered Approach, Complimentary Nutrition Consultation</li>
      <li><strong>Physiotherapy Premium (No. 1 Choice):</strong> Personalized one-on-one training, 5 sessions/week (20/month), Body Composition (2 sessions), Data Tracking, Complimentary Nutrition Consultation</li>
      <li><strong>S&C Standard:</strong> 5 sessions/week (20/month), Prehab/Rehab sessions, Strength & Power testing, Complimentary Nutrition Consultation</li>
      <li><strong>Elite S&C Premium:</strong> 5 sessions/week (20/month), Personalized training, Body Composition (2 sessions), Ice Bath (2 sessions), Strength & Muscle testing, Complimentary Nutrition Consultation</li>
    </ul>

    <h2>Premium Add-On Services</h2>
    <ul>
      <li>Ice Bath Recovery</li>
      <li>Cold Compression Therapy (1 limb, 10 mins) /  (2 limbs, 20 mins)</li>
      <li>Advanced Taping (service) / (service + tape)</li>
      <li>Clinical Body Composition Analysis </li>
      <li>Deep Tissue Massage (per limb, 30 mins) / (full body, 45 mins) / (trigger point release, 10 mins)</li>
    </ul>

    <p><em>“Disease is more expensive than health. Let’s prioritize your well-being without compromising on the top-rated quality of care you deserve.”</em></p>
  </div>
  </>
);

export default Membership;